import { dateFormatter2 as dateFormatter, DateFormatTypes } from '@jfs/utils'
import { Settlement } from '../../data/models/Settlements'
import { parsePage } from './TransactionsParser'

const getFileName = (name: string): string => {
  // Commented : As file name was going with ... and api was failing
  // let newName
  // if (name.length > 25) {
  //   newName = name.slice(0, 25) + '...'
  // }
  return name
}

const settlementParser = (resp: any) => {
  const pagination = parsePage(resp?.page)
  const getContent = () => {
    return (
      resp?.content?.map((data: any) =>
        Settlement.create({
          id: data?.fileName ?? 'NA',
          referenceNumber: data?.settlementReferenceNumber ?? 'NA',
          settledAmount: data?.settledTransactionAmount ? (+data?.settledTransactionAmount).toFixed(2) : '0',
          date: dateFormatter(data?.settlementDate ?? 'NA', DateFormatTypes.DATE_ONLY),
          fromDate: data?.startDateTime, //dateFormatter(data?.startDateTime ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
          toDate: data?.endDateTime, //dateFormatter(data?.endDateTime ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
          settledTransactionCount: +data?.settledTransactionCount ?? 0,
          refundCount: +data?.refundCount ?? 0,
          refundAmount: +data?.refundAmount ?? 0,
          settlementAmount: data?.settlementAmount ? (+data?.settlementAmount).toFixed(2) : '0',
          fileName: data?.fileName ? getFileName(data?.fileName) : 'NA',
          action: data?.action ?? 'Download',
          settlementDate: data?.settlementDate ?? '',
        }),
      ) ?? []
    )
  }
  return { content: getContent(), page: pagination }
}

const settlementMobileParser = (resp: any) => {
  const getContent = () => {
    return (
      resp?.content?.map((data: any) =>
        Settlement.create({
          id: data?.fileName ?? 'NA',
          referenceNumber: data?.settlementReferenceNumber ?? data?.settlementRefNumber ?? 'NA',
          settledAmount: data?.settledTransactionAmount ? (+data?.settledTransactionAmount).toFixed(2) : '0',
          date: dateFormatter(data?.settlementDate ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME), // timestamp txnItem?.transactionDateTime ?? 'NA', // timestamp
          // date: NewDateFormatter(data?.settlementDate ?? 'NA', NewDateFormatterType.DD_MMM_YYYY_HH_MM_AMPM),
          fromDate: data?.startDateTime, //dateFormatter(data?.startDateTime ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
          toDate: data?.endDateTime, //dateFormatter(data?.endDateTime ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
          settledTransactionCount: data?.settledTransactionCount ? +data?.settledTransactionCount : 0,
          refundCount: data?.refundCount ? +data?.refundCount : 0,
          refundAmount: data?.refundAmount ? +data?.refundAmount : 0,
          settlementAmount: data?.settlementAmount ? (+data?.settlementAmount).toFixed(2) : '0',
          fileName: data?.fileName ? getFileName(data?.fileName) : 'NA',
          settlementDate: data?.settlementDate ?? '',
        }),
      ) ?? []
    )
  }
  return { content: getContent() }
}

const updateSettlementGeneratedParser = (data: any, generatedData: any) => {
  const sData = data?.filter((item) => item?.id !== 'loading') ?? []
  const fData = JSON.parse(JSON.stringify(settlementParser(generatedData?.content)))
  const content = [...fData, ...sData]
  const page = generatedData?.page
  return { content, page }
}

const getLoadingData = () => {
  return {
    id: 'loading',
    action: 'Download',
    referenceNumber: '',
    settledAmount: 0,
    date: dateFormatter('' + Date.now(), DateFormatTypes.DATE_AM_PM),
    settledTransactionCount: 0,
    refundCount: 0,
    refundAmount: 0,
    settlementAmount: 0,
    fileName: '',
    loading: 'Generating Report... it will be available for the download once processing is complete',
  }
}

// any error
const deleteLoadingSettlement = (data: any[]) => {
  return data?.filter((item) => item?.id !== 'loading') ?? []
}

export {
  settlementParser,
  updateSettlementGeneratedParser,
  getLoadingData,
  deleteLoadingSettlement,
  settlementMobileParser,
}
